import React from 'react'

import BaseModal from '../BaseModal'
import './index.css'
import ButtonPrimary from '../ui/ButtonPrimary'
import ButtonSecondary from '../ui/ButtonSecondary'

const FinalizeCountingResultsModal = (props) => {

  const body = (
    <div className='finalize__counting__result_container'>
      <h2>Please confirm the php run</h2>
      <div className='finalize__counting__result_btn_section'>
       <ButtonPrimary onClick={props.onSelect} name = "Confirm" />
       <ButtonSecondary name = "Cancel" onClick = {props.onClose} />
      </div>
    </div>
  )


  return (
    <BaseModal
      onClose={props.onClose}
      body={body}
    />
  )
}


export default FinalizeCountingResultsModal;
